<template>
    <div>
        <div v-if="editing"
             class="w-100">
            <b-form-input
                ref="input"
                v-model="localValue"
                class="input-auto"
                autofocus
                debounce="500"
                @focus.native="whenFocus"
                @blur="whenBlur"
                @keydown.enter="commit">
            </b-form-input>
        </div>
        <template v-else>
            <b-badge variant="light" class="badge-text"
                     @click="editing=true">
                {{ hasCode(localValue) ? valueLabel + localValue : defaultValue }}
            </b-badge>
        </template>
    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ClickEdit",
    mixins: [emCommonUtilMixin],
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: null,
        valueLabel: {
            type: String,
            default: ''
        },
        defaultValue: String,
    },
    data() {
        return {
            editing: false,
            localValue: this.value,
        }
    },
    watch: {
        localValue() {
            this.$emit('update:value', this.localValue);
            this.$emit('change', this.localValue);
        },
        value: {
            handler() {
                this.localValue = this.value;
            },
            immediate: true
        },
    },
    methods: {
        whenBlur() {
            // Removing the focused input (editing=false) makes the browser fire a
            // second blur on the detached node — ignore it so we only save once.
            if (!this.editing) {
                return;
            }
            this.editing = false;
            // localValue is committed synchronously on blur, but it reaches the parent
            // through the `update:value` watcher (next tick). Defer the save event so the
            // parent reads the latest value instead of the previous one.
            this.$nextTick(() => this.$emit('inputBlur'));
        },
        commit() {
            // Enter: blur the input so the value is committed and whenBlur runs exactly once.
            if (this.$refs.input) {
                this.$refs.input.blur();
            }
        },
        whenFocus() {
            if (!this.hasCode(this.localValue) && this.hasCode(this.defaultValue)) {
                this.localValue = this.defaultValue;
                this.$refs.input.select();
            }
        },
    }
}
</script>

<style scoped>
.badge-text {
    font-size: .8rem;
    padding: .5rem;
}

.input-auto {
    width: max-content !important;
}
</style>
